import styled from 'styled-components';

export const CustomerPointBreakdownContainerStyled = styled.div`
  position: relative;
  width: 92vw;
  max-width: 1040px;
  max-height: 88vh;
  overflow: auto;
  padding: 1.5rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 8px;
  font-size: 14px;
  .modal_head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 14px;
    .modal_title {
      font-size: 18px;
    }
    .modal_sub {
      margin-top: 2px;
      font-size: 13px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .close_btn {
      cursor: pointer;
      font-size: 18px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      padding: 0 4px;
    }
  }
  .empty {
    padding: 2rem;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .stat_row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 14px;
    .stat_box {
      flex: 1;
      min-width: 140px;
      padding: 10px 14px;
      border: 1px solid #dbe4f0;
      border-radius: 8px;
      background: #f7f9fc;
      .stat_label {
        font-size: 12px;
        color: ${({ theme }) => theme.COLORS.GRAY_2};
      }
      .stat_value {
        margin-top: 2px;
        font-size: 18px;
        color: ${({ theme }) => theme.COLORS.BLUE_7};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
      &.stat_ok .stat_value {
        color: ${({ theme }) => theme.COLORS.GREEN_1};
      }
      &.stat_danger {
        border-color: #f5c2c2;
        background: #fff5f5;
        .stat_value {
          color: #c62828;
        }
      }
    }
  }
  .next_box {
    margin-bottom: 16px;
    padding: 10px 14px;
    border: 1px solid #ffd9a8;
    border-radius: 6px;
    background: #fff8ec;
    font-size: 13px;
    line-height: 1.6;
    .next_title {
      color: #8a4b00;
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .next_desc {
      color: #435466;
    }
  }
  .section {
    margin-bottom: 16px;
    .section_title {
      margin-bottom: 8px;
      color: #2b4a70;
    }
  }
  .table_wrap {
    overflow-x: auto;
  }
  .ledger_wrap {
    max-height: 320px;
    overflow-y: auto;
  }
  .item_table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    th,
    td {
      padding: 6px 8px;
      border: 1px solid #e4e8ee;
      text-align: left;
      vertical-align: top;
    }
    th {
      background: #f2f6fc;
      white-space: nowrap;
      position: sticky;
      top: 0;
    }
    .right {
      text-align: right;
    }
    .center {
      text-align: center;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .bold {
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .nowrap {
      white-space: nowrap;
    }
    .plus {
      color: ${({ theme }) => theme.COLORS.GREEN_1};
    }
    .minus {
      color: #c62828;
    }
    .remark {
      min-width: 220px;
      word-break: break-word;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    /* แถวที่ replay ไม่นับ (is_counted=false) ย้อมเทาทั้งแถว */
    tr.not_counted td {
      background: #f5f5f5;
      color: ${({ theme }) => theme.COLORS.GRAY_5};
    }
    .not_counted_note {
      margin-bottom: 2px;
      font-size: 12px;
      color: ${({ theme }) => theme.COLORS.GRAY_5};
      font-style: italic;
    }
  }
  .status_badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
    background: ${({ theme }) => theme.COLORS.GRAY_1};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .status_success {
    background: #e3f4e3;
    color: ${({ theme }) => theme.COLORS.GREEN_1};
  }
  .status_fail {
    background: #fde4e4;
    color: #c62828;
  }
  .status_processing {
    background: #fff3dc;
    color: #b26a00;
  }
  .action_zone {
    display: flex;
    justify-content: flex-end;
    .btn_box {
      width: 140px;
    }
  }
`;
